import React from 'react';
import { TeamMemberCard } from './TeamMemberCard';
interface TeamMember {
  id: string;
  name: string;
  pendingCount: number;
  totalLoans: number;
  lastActivity: string;
}
interface TeamMemberListProps {
  members: TeamMember[];
  onSelectMember: (memberId: string) => void;
}
export function TeamMemberList({
  members,
  onSelectMember
}: TeamMemberListProps) {
  return <div data-id="element-168">
      <div className="mb-4" data-id="element-169">
        <h2 className="text-base font-semibold text-gray-900" data-id="element-170">Your Team</h2>
        <p className="text-sm text-gray-500 mt-0.5" data-id="element-171">
          Loan Officer Assistants with funded loans requiring follow-up
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-id="element-172">
        {members.map(member => <TeamMemberCard key={member.id} name={member.name} pendingCount={member.pendingCount} totalLoans={member.totalLoans} lastActivity={member.lastActivity} onViewLoans={() => onSelectMember(member.id)} data-id="element-173" />)}
      </div>
    </div>;
}